import React, { ReactNode } from 'react'
import { StBaseTable } from './style'

type ColumnItem = [string | any, number]

type Column = ColumnItem[]

interface Props {
  children: ReactNode
  column: Column
  border?: boolean
  widthPer?: number
}

const BaseTable = ({ children, column, border, widthPer }: Props) => {
  return (
    <StBaseTable border={border} widthPer={widthPer}>
      <thead>
        <tr>
          {column.map(([title, width]) => (
            <th key={title} style={{ width: width + '%' }}>
              {title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </StBaseTable>
  )
}

export default BaseTable
